import {
  Combobox,
  type ComboboxProps,
  FormField,
  type FormFieldProps,
} from '@moia-dev/pace-web'
import { useId } from 'react'

export type ComboboxFieldProps<Value> = Omit<FormFieldProps, 'children'> &
  Omit<ComboboxProps<Value>, 'id'> & {
    id?: string
  }

export const ComboboxField = <Value,>({
  label,
  name,
  caption,
  id: maybeId,
  validation,
  required,
  maxLength,
  value,
  ...props
}: ComboboxFieldProps<Value>) => {
  const generatedId = useId()
  const id = maybeId ? maybeId : generatedId

  return (
    <FormField
      value={value}
      required={required}
      maxLength={maxLength}
      caption={caption}
      label={label}
      htmlFor={id}
      validation={validation}
    >
      {/* TODO: add ref prop to Combobox */}
      <Combobox {...props} id={id} value={value} />
    </FormField>
  )
}
